<template>
  <div>
    <div class="event-schedule-area-two bg-color pad100">

        <div class="row">
            <div class="col-lg-12 pb-3 mb-3" style="border-bottom: 1px solid #dee2e6;">
                <div class="section-title text-center">
                    <h2 class="h5 font-weight-bold text-secondary mb-2">
                      Outras publicações
                    </h2>
                    <p class="small text-muted mb-0">
                      Lista de materiais e comunicados no site.
                    </p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">

              <div class="tab-content" id="myTabContent">
                  <div class="tab-pane fade active show" id="home" role="tabpanel">
                      <div class="table-responsive">
                          <table class="table">

                              <tbody>
                                    <!-- Concurso para Câmara Municipal de Caarapó/MS -->
                                    <!-- <tr class="inner-box">
                                        <th scope="row">
                                            <div class="event-date">
                                                <span>10</span>
                                                <p>Janeiro / 2023</p>
                                            </div>
                                        </th>
                                        <td>
                                            <div class="event-img">
                                                <img src="../../assets/images/ibcgp/publications/publication-05/brasao-caarapo.png" alt="Miniatura Brasão Município de Caarapó" />
                                            </div>
                                        </td>
                                        <td>
                                            <div class="event-wrap">
                                                <a href="/publicacao/concurso-camara-caarapo">
                                                    <h3 style="color:#007bff;">
                                                        <b>
                                                            Concurso para Câmara Municipal de Caarapó/MS
                                                        </b>
                                                    </h3>
                                                </a>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="r-no">
                                                <span><b>Por:</b> Kalil Mustafa</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="primary-btn">
                                                <a class="" target="_blank" href="https://www.instagram.com/p/CnSJKJ0pGkX/">
                                                    <i class="instagram ti-instagram"></i>
                                                </a>
                                            </div>
                                        </td>
                                    </tr> -->

                                    <!-- Simples Nacional - Treinamento do SEFISC -->
                                    <!-- <tr class="inner-box">
                                        <th scope="row">
                                            <div class="event-date">
                                                <span>07</span>
                                                <p>Outubro / 2022</p>
                                            </div>
                                        </th>
                                        <td>
                                            <div class="event-img">
                                                <img src="../../assets/images/ibcgp/publications/mintreinamentosefisc4.png" alt="Miniatura Imagem Recurso ICMS" />
                                            </div>
                                        </td>
                                        <td>
                                            <div class="event-wrap">
                                                <a href="/publicacao/treinamento-sefisc-4.0">
                                                    <h3 style="color:#007bff;">
                                                        <b>
                                                            Simples Nacional - Treinamento do SEFISC - Versão 4.0
                                                        </b>
                                                    </h3>
                                                </a>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="r-no">
                                                <span><b>Por:</b> Kalil Mustafa</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="primary-btn">
                                                <a class="" target="_blank" href="https://www.instagram.com/p/Cjai1e0O-HM/">
                                                    <i class="instagram ti-instagram"></i>
                                                </a>
                                            </div>
                                        </td>
                                    </tr> -->

                                    <!-- Passo a passo para protocolar recursos de ICMS -->
                                    <!-- <tr class="inner-box">
                                        <th scope="row">
                                            <div class="event-date">
                                                <span>19</span>
                                                <p>Agosto / 2022</p>
                                            </div>
                                        </th>
                                        <td>
                                            <div class="event-img">
                                                <img src="../../assets/images/ibcgp/publications/minrecursoicms.png" alt="Miniatura Imagem Recurso ICMS" />
                                            </div>
                                        </td>
                                        <td>
                                            <div class="event-wrap">
                                                <a href="/publicacao/passo-a-passo-protocolar-recurso-icms">
                                                    <h3 style="color:#007bff;">
                                                        <b>
                                                            Passo a passo para protocolar recursos de ICMS
                                                        </b>
                                                    </h3>
                                                </a>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="r-no">
                                                <span><b>Por:</b> Kalil Mustafa</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="primary-btn">
                                                <a class="" target="_blank" href="https://www.instagram.com/p/ChcW3WwuWib/">
                                                    <i class="instagram ti-instagram"></i>
                                                </a>
                                            </div>
                                        </td>
                                    </tr> -->

                                    <!-- Plataforma de Administração Tributária Digital -->
                                    <!-- <tr class="inner-box">
                                        <th scope="row">
                                            <div class="event-date">
                                                <span>05</span>
                                                <p>Agosto / 2022</p>
                                            </div>
                                        </th>
                                        <td>
                                            <div class="event-img">
                                                <img src="../../assets/images/ibcgp/publications/minplataformaadmintribdigital.png" alt="Miniatura Imagem Dívida Ativa" />
                                            </div>
                                        </td>
                                        <td>
                                            <div class="event-wrap">
                                                <a href="/publicacao/plataforma-administracao-tributaria-digital">
                                                    <h3 style="color:#007bff;">
                                                        <b>
                                                            Plataforma de Administração Tributária Digital
                                                        </b>
                                                    </h3>
                                                </a>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="r-no">
                                                <span><b>Por:</b> Kalil Mustafa</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="primary-btn">
                                                <a class="" target="_blank" href="https://www.instagram.com/p/ChAhfvJpuG6/">
                                                    <i class="instagram ti-instagram"></i>
                                                </a>
                                            </div>
                                        </td>
                                    </tr> -->

                                    <!-- Vamos falar de Dívida Ativa? -->
                                    <!-- <tr class="inner-box">
                                        <th scope="row">
                                            <div class="event-date">
                                                <span>23</span>
                                                <p>Maio / 2022</p>
                                            </div>
                                        </th>
                                        <td>
                                            <div class="event-img">
                                                <img src="../../assets/images/ibcgp/publications/mindividaativa.png" alt="Miniatura Imagem Dívida Ativa" />
                                            </div>
                                        </td>
                                        <td>
                                            <div class="event-wrap">
                                                <a href="/publicacao/divida-ativa">
                                                    <h3 style="color:#007bff;">
                                                        <b>
                                                            Vamos falar de Dívida Ativa?
                                                        </b>
                                                    </h3>
                                                </a>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="r-no">
                                                <span><b>Por:</b> Michele Belizário</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="primary-btn">
                                                <a class="" target="_blank" href="https://www.instagram.com/p/Cd57Bvau4qR/">
                                                    <i class="instagram ti-instagram"></i>
                                                </a>
                                            </div>
                                        </td>
                                    </tr> -->

                                    <!-- Exemplos comentados originais -->
                                    <!-- <tr class="inner-box">
                                      <th scope="row">
                                          <div class="event-date">
                                              <span>20</span>
                                              <p>Novembar</p>
                                          </div>
                                      </th>
                                      <td>
                                          <div class="event-img">
                                              <img src="https://bootdey.com/img/Content/avatar/avatar2.png" alt="" />
                                          </div>
                                      </td>
                                      <td>
                                          <div class="event-wrap">
                                              <h3><a href="#">Toni Duggan</a></h3>
                                              <div class="meta">
                                                  <div class="organizers">
                                                      <a href="#">Aslan Lingker</a>
                                                  </div>
                                                  <div class="categories">
                                                      <a href="#">Inspire</a>
                                                  </div>
                                                  <div class="time">
                                                      <span>05:35 AM - 08:00 AM 2h 25'</span>
                                                  </div>
                                              </div>
                                          </div>
                                      </td>
                                      <td>
                                          <div class="r-no">
                                              <span>Room D3</span>
                                          </div>
                                      </td>
                                      <td>
                                          <div class="primary-btn">
                                              <a class="btn btn-primary" href="#">Read More</a>
                                          </div>
                                      </td>
                                  </tr>

                                  <tr class="inner-box">
                                      <th scope="row">
                                          <div class="event-date">
                                              <span>18</span>
                                              <p>Novembar</p>
                                          </div>
                                      </th>
                                      <td>
                                          <div class="event-img">
                                              <img src="https://bootdey.com/img/Content/avatar/avatar3.png" alt="" />
                                          </div>
                                      </td>
                                      <td>
                                          <div class="event-wrap">
                                              <h3><a href="#">Billal Hossain</a></h3>
                                              <div class="meta">
                                                  <div class="organizers">
                                                      <a href="#">Aslan Lingker</a>
                                                  </div>
                                                  <div class="categories">
                                                      <a href="#">Inspire</a>
                                                  </div>
                                                  <div class="time">
                                                      <span>05:35 AM - 08:00 AM 2h 25'</span>
                                                  </div>
                                              </div>
                                          </div>
                                      </td>
                                      <td>
                                          <div class="r-no">
                                              <span>Room A3</span>
                                          </div>
                                      </td>
                                      <td>
                                          <div class="primary-btn">
                                              <a class="btn btn-primary" href="#">Read More</a>
                                          </div>
                                      </td>
                                  </tr> -->
                              </tbody>

                          </table>
                      </div>
                  </div>
              </div>

          </div>
        </div>

    </div>
  </div>
</template>

<script>
  export default {}
</script>

<style scoped>
  .event-schedule-area-two .section-title .title-text h2 {
      margin: 0px 0 15px;
  }

  .event-schedule-area-two ul.custom-tab {
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      border-bottom: 1px solid #dee2e6;
      margin-bottom: 30px;
  }
  .event-schedule-area-two ul.custom-tab li {
      margin-right: 70px;
      position: relative;
  }
  .event-schedule-area-two ul.custom-tab li a {
      color: #252525;
      font-size: 25px;
      line-height: 25px;
      font-weight: 600;
      text-transform: capitalize;
      padding: 35px 0;
      position: relative;
  }
  .event-schedule-area-two ul.custom-tab li a:hover:before {
      width: 100%;
  }
  .event-schedule-area-two ul.custom-tab li a:before {
      position: absolute;
      left: 0;
      bottom: 0;
      content: "";
      background: #4125dd;
      width: 0;
      height: 2px;
      -webkit-transition: all 0.4s;
      -o-transition: all 0.4s;
      transition: all 0.4s;
  }
  .event-schedule-area-two ul.custom-tab li a.active {
      color: #4125dd;
  }

  .event-schedule-area-two .primary-btn {
      margin-top: 40px;
  }

  .event-schedule-area-two .tab-content .table {
      -webkit-box-shadow: 0 1px 30px rgba(0, 0, 0, 0.1);
      box-shadow: 0 1px 30px rgba(0, 0, 0, 0.1);
      margin-bottom: 0;
  }
  .event-schedule-area-two .tab-content .table thead {
      background-color: #007bff;
      color: #fff;
      font-size: 20px;
  }
  .event-schedule-area-two .tab-content .table thead tr th {
      padding: 20px;
      border: 0;
  }
  .event-schedule-area-two .tab-content .table tbody {
      background: #fff;
  }
  .event-schedule-area-two .tab-content .table tbody tr.inner-box {
      border-bottom: 1px solid #dee2e6;
  }
  .event-schedule-area-two .tab-content .table tbody tr th {
      border: 0;
      padding: 30px 20px;
      vertical-align: middle;
  }
  .event-schedule-area-two .tab-content .table tbody tr th .event-date {
      color: #252525;
      text-align: center;
  }
  .event-schedule-area-two .tab-content .table tbody tr th .event-date span {
      font-size: 50px;
      line-height: 50px;
      font-weight: normal;
  }
  .event-schedule-area-two .tab-content .table tbody tr td {
      padding: 30px 20px;
      vertical-align: middle;
  }
  .event-schedule-area-two .tab-content .table tbody tr td .r-no span {
      color: #252525;
  }
  .event-schedule-area-two .tab-content .table tbody tr td .event-wrap h3 a {
      font-size: 20px;
      line-height: 20px;
      color: #cf057c;
      -webkit-transition: all 0.4s;
      -o-transition: all 0.4s;
      transition: all 0.4s;
  }
  .event-schedule-area-two .tab-content .table tbody tr td .event-wrap h3 a:hover {
      color: #4125dd;
  }
  .event-schedule-area-two .tab-content .table tbody tr td .event-wrap .categories {
      display: -webkit-inline-box;
      display: -ms-inline-flexbox;
      display: inline-flex;
      margin: 10px 0;
  }
  .event-schedule-area-two .tab-content .table tbody tr td .event-wrap .categories a {
      color: #252525;
      font-size: 16px;
      margin-left: 10px;
      -webkit-transition: all 0.4s;
      -o-transition: all 0.4s;
      transition: all 0.4s;
  }
  .event-schedule-area-two .tab-content .table tbody tr td .event-wrap .categories a:before {
      content: "\f07b";
      font-family: fontawesome;
      padding-right: 5px;
  }
  .event-schedule-area-two .tab-content .table tbody tr td .event-wrap .time span {
      color: #252525;
  }
  .event-schedule-area-two .tab-content .table tbody tr td .event-wrap .organizers {
      display: -webkit-inline-box;
      display: -ms-inline-flexbox;
      display: inline-flex;
      margin: 10px 0;
  }
  .event-schedule-area-two .tab-content .table tbody tr td .event-wrap .organizers a {
      color: #4125dd;
      font-size: 16px;
      -webkit-transition: all 0.4s;
      -o-transition: all 0.4s;
      transition: all 0.4s;
  }
  .event-schedule-area-two .tab-content .table tbody tr td .event-wrap .organizers a:hover {
      color: #4125dd;
  }
  .event-schedule-area-two .tab-content .table tbody tr td .event-wrap .organizers a:before {
      content: "\f007";
      font-family: fontawesome;
      padding-right: 5px;
  }
  .event-schedule-area-two .tab-content .table tbody tr td .primary-btn {
      margin-top: 0;
      text-align: center;
  }
  .event-schedule-area-two .tab-content .table tbody tr td .event-img img {
      width: 100px;
      height: 100px;
      border-radius: 8px;
  }

  .instagram{
    font-size: 25px;
  }
</style>